export enum SmartCollectionVariant {
  HEAVY_ROTATION = 'Heavy Rotation',
  BEST_NEW_RELEASES = 'Best New Releases',
  UNDER_THE_RADAR = 'Under The Radar',
  MOST_LOVED = 'Most Loved',
  FEELING_LUCKY = 'Feeling Lucky?',
  REMIXABLES = 'Remixables'
}
